module.exports = __webpack_public_path__ + "static/media/contact-img.163081d0.svg";